import { render, staticRenderFns } from "./ModalBulkApproveTemuan.vue?vue&type=template&id=d9d78d6e&"
import script from "./ModalBulkApproveTemuan.vue?vue&type=script&lang=js&"
export * from "./ModalBulkApproveTemuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports